import {
  type Action,
  type ControlType,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

export enum GamePageSection {
  GALLERY = "Gallery",
  GAMEPLAY = "Gameplay",
  RIGHT_PANEL = "RightPanel",
  BENTO = "Bento",
  TRAILER = "Trailer",
  PLATFORMS = "Platforms",
  SOCIALS = "Socials",
  ONBOARDING_MODAL = "OnboardingModal",
}

type GamePageExtras = {
  control?: string;
  controlType?: ControlType;
  controlLabel?: string;
  section?: GamePageSection;
};

export type GamePageEvent = { action: Action; extras: GamePageExtras };

export const useGamePageAnalytics = () =>
  useAnalyticsTracker<GamePageEvent>(TrackObject.GAME_PAGE);
